var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnPellets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.67 56.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#4b4a4a;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.81,
    cy: 50.28,
    r: 4.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.67 15.48 23.62 17a8.75 8.75 0 0 1-.91 3.81 5.8 5.8 0 0 1-1.52 1.86.38.38 0 0 1-.16 0h-.09l-.19-.08a5.82 5.82 0 0 1-.51-.31c-.19-.12-1.38-1-1.89-1.43a.23.23 0 0 0-.35.09 13.09 13.09 0 0 0-1.16 3.5c-.06 1.8.79 3.7 2.69 6a.32.32 0 0 1 0 .36.3.3 0 0 1-.25.14h0-.1a15 15 0 0 1-5.81-3.39 8.26 8.26 0 0 1-2.62-5.89c0-4.9 2.06-7.07 4.25-9.36a18.35 18.35 0 0 0 5.73-11.2.31.31 0 0 1 .27-.25h0a.33.33 0 0 1 .21.07l.71.63c4.23 3.85 7 7.09 8.7 10.17A19.2 19.2 0 0 1 33 21.51c0 5.12-4.31 8.78-8.48 9.37h0a.32.32 0 0 1-.3-.18.29.29 0 0 1 .07-.34 9.65 9.65 0 0 0 3.35-6.71c0-2.19-1-4.56-3-7l-.95-1.14M10.77 45.32H35.9a5 5 0 0 0 0-9.92H10.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.72 55.23h25.14a5 5 0 1 0 0-9.91H15.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.77,
    cy: 40.36,
    r: 4.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.72,
    cy: 50.28,
    r: 4.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.68 55.23H5.81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPellets);
export default __webpack_public_path__ + "static/media/icn-pellets.59e5e27917a33be8512539a83ef62623.svg";
export { ForwardRef as ReactComponent };